module.exports = __webpack_public_path__ + "img/image-6.7dc9dc73.webp";